module.exports = __webpack_public_path__ + "img/joel-muniz-3k3l2brxmwQ-unsplash.4cd363d0.jpg";